import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { ProductCover } from './ProductCover';
const FEATURED = {
  kicker: 'Mega Pack · Estética',
  tag: 'Producto destacado',
  title: 'Estética Digital PRO',
  href: 'https://esteticadigital.creativodigital.shop/',
  subtitle: 'Mega Pack para convertir seguidores en pacientes.',
  description: 'Más de 300 recursos editables, guiones de contenido, embudos de captación y prompts de IA para clínicas y profesionales de la estética.',
  bullets: ['300+ recursos editables', 'Embudos listos', 'Prompts de IA']
};
const PRODUCTS = [{
  kicker: 'Recursos de IA',
  scene: 'ai' as const,
  title: 'IA Toolkit',
  description: 'Biblioteca de prompts y flujos de automatización para crear contenido en minutos.'
}, {
  kicker: 'Sistema de diseño',
  scene: 'templates' as const,
  title: 'Plantillas Premium',
  description: 'Sistema de plantillas editables para redes, propuestas y landing pages.'
}, {
  kicker: 'Estrategia',
  scene: 'analytics' as const,
  title: 'Marketing Playbook',
  description: 'Estrategias paso a paso para lanzar, vender y escalar tu negocio digital.'
}];
const ease = [0.22, 1, 0.36, 1] as const;
export function Products() {
  return <section id="productos" className="relative w-full border-t border-white/[0.06] py-28 sm:py-32 lg:py-40" data-id="element-457" data-mp="13y82zwd70nux">
      <div className="mx-auto w-full max-w-content px-6 lg:px-8" data-id="element-458" data-mp="1rnj6vmpuayda">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-459" data-mp="1wkst6thxmtww">
          <div className="max-w-2xl" data-id="element-460" data-mp="1iv8vi237kmug">
            <p className="text-[12.5px] font-medium uppercase tracking-[0.18em] text-white/35" data-id="element-461" data-mp="1iu7ab4shajz0">
              Productos
            </p>
            <h2 className="mt-5 text-3xl font-semibold leading-tight tracking-[-0.02em] text-white sm:text-[2.6rem]" data-id="element-462" data-mp="2alvjxjjvgse5">
              Herramientas digitales listas para usar.
            </h2>
          </div>
          <a href="#contacto" className="inline-flex items-center gap-2 text-sm font-medium text-white/60 transition-colors hover:text-white" data-id="element-463" data-mp="2p82em0debj10">
            Ver catálogo completo
            <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-464" data-mp="2g6uquc8ia0l6" />
          </a>
        </div>

        <motion.article initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.65,
        ease
      }} className="group relative mt-16 overflow-hidden rounded-4xl border border-white/[0.08] bg-[#131317] lg:mt-20" data-id="element-465" data-mp="2b9ce0ardb17w">
          <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-70" style={{
          background: 'radial-gradient(80% 120% at 85% 10%, rgba(37,99,246,0.18), transparent 60%), radial-gradient(70% 100% at 15% 90%, rgba(139,92,246,0.16), transparent 65%)'
        }} data-id="element-466" data-mp="1xheaqgkc7zjn" />
          <div className="relative grid grid-cols-1 items-center gap-12 p-9 sm:p-14 lg:grid-cols-2 lg:gap-16" data-id="element-467" data-mp="18ex5zd4ed6v7">
            <div data-id="element-468" data-mp="1ddqj34fruvuu">
              <span className="inline-flex items-center rounded-full border border-white/12 bg-white/[0.04] px-3 py-1 text-[11.5px] font-medium uppercase tracking-[0.14em] text-white/60" data-id="element-469" data-mp="1dd733t9omhjg">
                {FEATURED.tag}
              </span>
              <h3 className="mt-7 text-3xl font-semibold tracking-[-0.02em] text-white sm:text-[2.4rem]" data-id="element-470" data-mp="pppiqisqylqi">
                {FEATURED.title}
              </h3>
              <p className="mt-4 text-[17px] font-light text-white/70" data-id="element-471" data-mp="uoto0ycjvzbk">
                {FEATURED.subtitle}
              </p>
              <p className="mt-6 max-w-lg text-[14.5px] font-light leading-relaxed text-white/45" data-id="element-472" data-mp="14ed8u9jtq392">
                {FEATURED.description}
              </p>
              <ul className="mt-8 flex flex-wrap gap-2.5" data-id="element-473" data-mp="6y6cm33ferk9">
                {FEATURED.bullets.map(b => <li key={b} className="rounded-full border border-white/[0.08] bg-white/[0.03] px-3.5 py-1.5 text-[12.5px] font-light text-white/60" data-id="element-474" data-mp="bwhmgdtq122h">
                    {b}
                  </li>)}
              </ul>
              <a href={FEATURED.href} target="_blank" rel="noopener noreferrer" className="group/btn brand-gradient-bg mt-11 inline-flex items-center gap-2 rounded-full px-6 py-3.5 text-sm font-medium text-white shadow-[0_20px_50px_-18px_rgba(90,80,246,0.85)] transition-all duration-300 hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50" data-id="element-475" data-mp="2nema4xarmerm">
                Ver Producto
                <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4 transition-transform duration-300 group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5" data-id="element-476" data-mp="31dc6ubtoacfg" />
              </a>
            </div>
            <div className="overflow-hidden rounded-3xl border border-white/[0.07] transition-transform duration-700 group-hover:scale-[1.02]" data-id="element-477" data-mp="3illhjv45lilv">
              <ProductCover title={FEATURED.title} kicker={FEATURED.kicker} scene="megapack" variant="featured" data-id="element-478" data-mp="3nkoppoffk4y2" />
            </div>
          </div>
        </motion.article>

        <ul className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-479" data-mp="2zvx0n5x502pi">
          {PRODUCTS.map((product, i) => <motion.li key={product.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          delay: i * 0.08,
          ease
        }} className="group flex flex-col overflow-hidden rounded-4xl border border-white/[0.07] bg-white/[0.02] transition-colors duration-300 hover:border-white/[0.16]" data-id="element-480" data-mp="34v08sz8eyp1p" data-mpi={i}>
              <div className="overflow-hidden border-b border-white/[0.06]" data-id="element-481" data-mp="t2tgxw4wzrnj">
                <div className="transition-transform duration-700 group-hover:scale-[1.03]" data-id="element-482" data-mp="rpblooksz36e">
                  <ProductCover title={product.title} kicker={product.kicker} scene={product.scene} data-id="element-483" data-mp="mnma97to4nhs" />
                </div>
              </div>
              <div className="flex flex-1 flex-col p-8 sm:p-9" data-id="element-484" data-mp="dqlt9m8xhrod">
                <h3 className="text-[18px] font-medium tracking-tight text-white" data-id="element-485" data-mp="1ae0679fdj6hn">
                  {product.title}
                </h3>
                <p className="mt-4 flex-1 text-[14px] font-light leading-relaxed text-white/45" data-id="element-486" data-mp="15hrmrju58r4o">
                  {product.description}
                </p>
                <a href="#contacto" className="mt-8 inline-flex items-center justify-center gap-2 rounded-full border border-white/12 bg-white/[0.03] px-5 py-3 text-sm font-medium text-white/85 transition-colors duration-300 hover:border-white/25 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/30" data-id="element-487" data-mp="wmbvnakrwq2s">
                  Ver Producto
                  <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-488" data-mp="3c28a63l0weu4" />
                </a>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}